/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pkl_Toast_Approve_PxkInputs */

const vi_pkl_toast_approve_pxk = /** @type {(inputs: Pkl_Toast_Approve_PxkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã duyệt phiếu xuất`)
};

/**

* @param {Pkl_Toast_Approve_PxkInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pkl_toast_approve_pxk = /** @type {((inputs?: Pkl_Toast_Approve_PxkInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pkl_Toast_Approve_PxkInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pkl_toast_approve_pxk(inputs)
});